import type { TrackingLabels } from '@shared/tracking/TrackingLabels.ts';
import type { SearchContext } from '@shared/types/types.ts';
import { GALLERY_LANDSCAPE, GALLERY_LANDSCAPE_TWO_COLUMN } from '@tilelist/domain/composition/BracketLayout.ts';
import type { BracketLayout } from '@tilelist/domain/composition/BracketLayout.ts';
import { EXPERIMENT_ONEX_IDS, type ExperimentOnexId } from '@tilelist/domain/experiments/Experiments.ts';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';
import { isBrandTileExperimentEligible } from '@tilelist/domain/feature-visibility/BrandTile.ts';
import { shouldShowInstallments } from '@tilelist/domain/feature-visibility/InstallmentVisibility.ts';
import { shouldShowTopInfos } from '@tilelist/domain/feature-visibility/TopInfoVisibility.ts';

type ExperimentDefinition = {
    /*                                                                                            */
    experimentId: ExperimentOnexId;
    /*                                                                                                                                  */
    experimentShouldBeTracked: boolean;
};

/**
 *
 *
 *
 */
type GenericExperimentDefinition = {
    experimentId: string;
    experimentShouldBeTracked: boolean;
};

/*                                                                                                                                                           */
const EXP_OVERRIDE_ID = 'noExperiment';

type ExperimentTrackingFacts = {
    searchContext: SearchContext;
    layout: BracketLayout;
    teaserVariationBoostShouldBeTracked: boolean;
};

function getExperimentDefinitions(facts: ExperimentTrackingFacts, onex: OnEx): ExperimentDefinition[] {
    const { searchContext, layout, teaserVariationBoostShouldBeTracked } = facts;
    const isLandscapeSegment =
        layout.imageAspectRatio === GALLERY_LANDSCAPE.imageAspectRatio ||
        layout.imageAspectRatio === GALLERY_LANDSCAPE_TWO_COLUMN.imageAspectRatio;

    return [
        {
            /*                                                               */
            experimentId: EXPERIMENT_ONEX_IDS.TEASER_VARIATION_BOOST,
            experimentShouldBeTracked: teaserVariationBoostShouldBeTracked,
        },
        {
            /*                                                                          */
            experimentId: EXPERIMENT_ONEX_IDS.TOP_INFO_SCANABILITY,
            experimentShouldBeTracked:
                shouldShowTopInfos(searchContext) && onex.isExperimentActive('TOP_INFO_SCANABILITY'),
        },
        {
            /*                                                               */
            /*                                                                */
            /*                                           */
            /*                                                              */
            /*                                                         */
            /*                                            */
            experimentId: EXPERIMENT_ONEX_IDS.GALLERY_LANDSCAPE_TWO_COLUMN,
            experimentShouldBeTracked: isLandscapeSegment && onex.isExperimentActive('GALLERY_LANDSCAPE_TWO_COLUMN'),
        },
        {
            experimentId: EXPERIMENT_ONEX_IDS.BRAND_TILE,
            experimentShouldBeTracked:
                isBrandTileExperimentEligible(searchContext) && onex.isExperimentActive('BRAND_TILE'),
        },
        {
            experimentId: EXPERIMENT_ONEX_IDS.INSTALLMENT_WARNING,
            experimentShouldBeTracked:
                shouldShowInstallments(searchContext) && onex.isExperimentActive('INSTALLMENT_WARNING'),
        },
    ];
}

/**
 *
 *
 *
 *
 */
export function aggregateExperimentTracking(definitions: GenericExperimentDefinition[]): {
    experimentIds: string[];
} {
    const trackedExperimentIds = definitions.filter((d) => d.experimentShouldBeTracked).map((d) => d.experimentId);

    return {
        experimentIds: trackedExperimentIds.length > 0 ? trackedExperimentIds : [EXP_OVERRIDE_ID],
    };
}

/*                                                                                          */
export function experimentSegmentTracking(
    facts: ExperimentTrackingFacts,
    onex: OnEx,
): Pick<TrackingLabels, 'wk.san_ReptileExperimentSegment'> {
    const { experimentIds } = aggregateExperimentTracking(getExperimentDefinitions(facts, onex));
    return { 'wk.san_ReptileExperimentSegment': experimentIds };
}
